<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-select v-model="searchParam.school_uuid" placeholder="校区筛选" clearable>
          <el-option v-for="item in schoolList" :key="item.uuid" :label="item.title" :value="item.uuid"></el-option>
        </el-select>

        <el-input v-model="searchParam.keyword_search" placeholder="请输入关键词搜索">
          <el-select slot="prepend" v-model="keys" placeholder="id" style="width: 100px">
            <el-option value="phone" label="手机号查询"></el-option>
            <el-option value="name" label="班主任名称"></el-option>
          </el-select>
        </el-input>
        <el-button type="primary" @click="getList">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </div>
      <div class="right">
        <el-button @click="exportData">导出查询结果</el-button>
        <el-button type="primary" @click="addStudent">新增老师</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="责任老师名称"> </el-table-column>
        <el-table-column prop="real_name" label="头像">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.avatar"
              fit="contain"
              :preview-src-list="[scope.row.avatar]"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>
        <el-table-column prop="school_uuid" label="所属学校">
          <template slot-scope="scope">
            {{ getSchoolName(scope.row.school_uuid) }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getTeacherList, deleteTeacher, exportTeacher } from "@/api/teacher.js";
import areaSelect from "@/components/pub/areaSelect.vue";
import { mixin } from "@/mixins/pagination.js";
import { mschool } from "../mixins.js";

export default {
  components: {
    areaSelect,
  },
  mixins: [mixin, mschool],
  data() {
    return {
      keys: "phone",
      searchParam: {
        keyword_search: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getSchool();
  },
  methods: {
    exportData() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        type: 2,
      };
      exportTeacher(param);
    },
    resetSearch() {
      this.searchParam = {};
      this.getList();
    },
    getSchoolName(id) {
      const item = this.schoolList.find((item) => {
        return item.uuid == id;
      });
      if (item) {
        return item.title;
      }
    },
    addStudent() {
      this.$router.push({ path: "/teacher-responsible-add" });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({ path: "/teacher-responsible-add", query: row });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        type: 2,
      };
      // param[this.keys] = this.searchParam.keyword_search
      console.log(param);
      this.loading = true;
      const res = await getTeacherList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.total = res.total;
        this.tableData = res.data;
      }
      console.log(res);
    },
    deleteItem(row) {
      this.$confirm("确定要删除该老师吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTeacher(row.uuid).then((res) => {
            console.log(res);
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
